import getRouterBasename from "@/lib/router";
import { Navigate, createBrowserRouter } from "react-router-dom";

import AuthCallback from "pages/AuthCallback";
import Element from "pages/Element";
import Env from "pages/Env";
import Home from "pages/Home";
import Login from "pages/Login";
import Thread from "pages/Thread";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/env",
      element: <Env />,
    },
    {
      path: "/thread/:id?",
      element: <Thread />,
    },
    {
      path: "/element/:id",
      element: <Element />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/login/callback",
      element: <AuthCallback />,
    },
    {
      path: "*",
      element: <Navigate replace to="/" />,
    },
  ],
  { basename: getRouterBasename() },
);
